import { OpenInNew } from "@mui/icons-material";
import { Box, Button, CircularProgress, IconButton, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { useRecord } from "../../../../../api/useRecord";
import { Avatar } from "../../Avatar";

type OperationsStaffAgreementProps = {
    value: {
        operations_staff_agreement_id: string;
    };
};
export const OperationsStaffAgreement = ({ value }: OperationsStaffAgreementProps) => {
    const {data, status} = useRecord("staff_agreements", "*.*", value?.operations_staff_agreement_id);



  if(status === "loading") return <CircularProgress color="secondary" />;
  if(status === "error") return <div>Erro ao carregar acordo de trabalhador</div>;

  const staffAgreement = data.item;
  const user = staffAgreement.user;
  const userName = `${user.first_name} ${user.last_name}`;
  const url = `/staff_agreements/${staffAgreement.id}/detail`;
  
    return (
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Button variant="text" color="secondary" component={Link} to={url}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 4}}>
                    <Avatar value={user.avatar} />
                    <Typography>{userName}</Typography>
                </Box>
            </Button>
            <IconButton sx={{ p: 0 }} color="secondary" component={Link} to={url} target="_blank">
                <OpenInNew />
            </IconButton>
        </Box>
    );
};
